export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="rounded-2xl overflow-hidden relative h-[350px] md:h-[420px] mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Aesthetic%20lifestyle%20scene%20of%20a%20peaceful%20home%20office%20corner%20with%20an%20organized%20desk%20setup%20featuring%20a%20laptop%20spreadsheet%20a%20neatly%20stacked%20pile%20of%20fashion%20lookbooks%20and%20magazines%20a%20ceramic%20diffuser%20emitting%20subtle%20mist%20and%20a%20cozy%20throw%20blanket%20draped%20over%20a%20chair%20soft%20warm%20evening%20light%20from%20a%20Himalayan%20salt%20lamp%20creating%20ambient%20glow&width=1800&height=900&seq=cta-fashion-2026-v4&orientation=landscape"
            alt="Superbuy Sheet shopping experience"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 via-transparent to-transparent"></div>
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="text-2xl md:text-4xl leading-relaxed mb-10">
            <span className="text-foreground-400 italic font-light">Stop wasting hours </span>
            <br className="md:hidden" />
            <span className="text-foreground-400 italic font-light">on manual research </span>
            <br />
            <span className="text-foreground-400">with </span>
            <strong className="text-foreground-950 font-heading font-bold">Superbuy Sheet.</strong>
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center w-[220px] h-[56px] rounded-full bg-primary-500 text-background-50 text-base font-label font-medium whitespace-nowrap cursor-pointer transition-all hover:bg-primary-600"
          >
            buy it now
          </a>
        </div>
      </div>
    </section>
  );
}